module.exports = __webpack_public_path__ + "img/check-icon-on.99efd06d.svg";